export default {
    id: 'MEDCAL_RX_REQUIRED_FIELDS',
    defaultMessage: 'Required Fields'
};
